import type { Passkey } from "@esi/shared";
import { useTranslation } from "react-i18next";
import { AppDialog } from "@/components/AppDialog";
import { Button } from "@/components/ui/button";
import { DialogFooter } from "@/components/ui/dialog";

/**
 * Asks before a passkey is removed (#354), on the tenant account page and the console profile
 * alike: it names the passkey and says what removing it does. Nothing is sent until confirmed.
 */
export function RemovePasskeyDialog(props: {
  passkey: Passkey | null;
  /** Its name as the list shows it. */
  name: string;
  /** Another passkey action is running: confirming waits for it. */
  busy: boolean;
  onClose: () => void;
  onConfirm: (passkey: Passkey) => void;
}) {
  const { t } = useTranslation();
  const { passkey } = props;
  return (
    <AppDialog
      open={passkey !== null}
      onClose={props.onClose}
      title={passkey ? t("passkeys.removeTitle", { name: props.name }) : ""}
      description={t("passkeys.removeLead")}
    >
      {passkey ? (
        <DialogFooter>
          <Button variant="outline" onClick={props.onClose}>
            {t("app.cancel")}
          </Button>
          <Button
            variant="destructive"
            disabled={props.busy}
            onClick={() => props.onConfirm(passkey)}
          >
            {t("passkeys.removeConfirm")}
          </Button>
        </DialogFooter>
      ) : null}
    </AppDialog>
  );
}
